import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getDocument = (disputeId: string, attachmentId: string) => {
  return axiosPrivate.get(
    `/dashboard/api/v1/disputes/${disputeId}/attachments/${attachmentId}?download=1`,
    { responseType: 'blob' }
  );
};